import React from "react"
import MobileThreeDEditor from "../components/MobileThreeDEditor.jsx"

export default function MobileShopPage() {
    return (
        <MobileThreeDEditor />
    )
}